module.exports = __webpack_public_path__ + "static/media/live.5be3888c.jpg";